import sdkUrl from "@/api/sdkurl";

const webConfig =  {
    //应用名称
    appName: "汇玩",
    //应用名称
    gameAppName: "汇玩",
    //网页title
    webTitle: "汇玩-好游戏尽在汇玩",
    //应用图标
    logoUrl: require("@/assets/logo.png"),
    //圆形logo
    logoRoundUrl: require("@/assets/logo-round.png"),
    //微信公众号
    wechatUrl: "",
    //应用二维码
    appqrUrl: "",
    //icp备案
    icp: "冀ICP备2024067940号-2",
    //公安备案
    publicSecurity: "",
    //版权所有
    copyright: "copyright © 2025 huiwanyx.com/ All Rights Resered.",
    //公司地址
    address: "河北省石家庄市裕华区塔南路192号综合服务楼4楼A区25",
    //公司名称
    companyName: "石家庄新玩网络科技有限公司",
    //公司名称
    copyrightCompany: "汇玩游戏 版权所有",
    //app备案
    appRecord: "冀ICP备2024067940号-4A",
    //用户协议
    agreement :  "https://huiwanyx.com/static/agreement/user.html",
    //隐私政策
    privacy :  "https://huiwanyx.com/static/agreement/privacy.html",
    //QQ客服
    qqkfList: [
        // {"info": "", "worktime": ""}
    ],
    wxkfList: [
        {"info": "https://work.weixin.qq.com/kfid/kfcd32e3822e5e87d71", "worktime": "09:00-22:00"}
    ],
    telkfList: [
        // {"info": "", "worktime": ""}
    ],
    //平台币名称
    coinName: "汇玩币",
    bindCoinName: '绑币',
    //游戏加速器地址
    speedUrl: "https://huiwanyx.com/static/speed/a.html?genCode=true",
    //sdkweb地址
    sdkUrl: sdkUrl,
    //默认搜索游戏名
    defaultSearchName: "天斗服",
    hotSearchName: ["斗罗大陆", "天斗服"],
    redirectUri: "https://huiwanyx.com/#/selfPayWX",
    appid: "wxda31613b83d8400f",
}

export default webConfig